import { omit } from 'lodash';
import * as Immutable from 'immutable';
import { createReducer } from '../utils';
import * as actionTypes from '../actionTypes/advancedSearchActionTypes';
import { formDefaults } from '../../components/advancedSearch/formData';

const initialState = Immutable.fromJS({
  filter: {
    grouped: false,
    page: 0,
    do_search: false,
  },
  resultsFilter: {
    grouped: false,
    page: 0,
    // do_search: false,
  },
  data: {},
  error: null,
  isLoading: false,
  showResults: false,
  alert: {
    isLoading: false,
    error: null,
    data: {
      name: null,
      delivery: null,
      notify_interval: null,
      notify_interval_label: null,
      meta: {},
    },
  },
});

function getTemplate(tab) {
  const templateMap = {
    general: 'general',
    cases: 'case_lookup',
    'case-activity': 'case_activity',
    petitions: 'extended',
    schedules: 'schedules',
  };
  return templateMap[tab];
}

export default createReducer(initialState, {
  [actionTypes.ADVANCED_SEARCH_ALL_GENERAL.REQUEST]: (state, { payload }) =>
    state.merge(
      Immutable.fromJS({
        isLoading: true,
        filter: payload,
        resultsFilter: payload,
        showResults: true,
        data: {},
      })
    ),

  [actionTypes.ADVANCED_SEARCH_ALL_GENERAL.ERROR]: (state, { error }) =>
    state.merge(Immutable.fromJS({ error, isLoading: false })),

  [actionTypes.ADVANCED_SEARCH_ALL_GENERAL.SUCCESS]: (state, { data }) =>
    state.merge(
      Immutable.fromJS({
        data,
        isLoading: false,
      })
    ),

  [actionTypes.ADVANCED_SEARCH_RESET]: state => {
    const court_type = state.getIn(['filter', 'court_type']);
    const tab = state.getIn(['filter', 'tab']);
    const selectedFilter = formDefaults[court_type][tab];

    return initialState
      .set(
        'filter',
        Immutable.fromJS({
          ...selectedFilter.default,
          ...selectedFilter.mustHave,
          page: 0,
          court_type,
          tab,
          template: getTemplate(tab),
        })
      )
      .set('history', state.get('history'));
  },

  [actionTypes.ADVANCED_SEARCH_FORM_FILTER_SET]: (state, { payload: { courtType, tab, queryParams, history } }) => {
    const selectedFilter = formDefaults[courtType][tab];
    // clear extra fields from result filters, leave only common ones
    const resultFilter = omit(state.get('resultsFilter').toJS(), Object.keys(selectedFilter.omit));

    return state
      .set(
        'filter',
        Immutable.fromJS(
          queryParams && queryParams.do_search && !state.get('showResults')
            ? {
                ...selectedFilter.default,
                ...queryParams,
                court_type: courtType,
                tab,
                template: getTemplate(tab),
              }
            : {
                ...selectedFilter.default,
                ...resultFilter,
                ...selectedFilter.mustHave,
                page: 0,
                court_type: courtType,
                tab,
                template: getTemplate(tab),
              }
        )
      )
      .set('history', Immutable.fromJS(history));
  },

  [actionTypes.ADVANCED_SEARCH_URL_PARAMS_UPDATE]: (state, { payload }) => {
    const history = state.get('history').toJS();

    if (history) {
      history.replace({ search: payload });
    }

    return state;
  },

  [actionTypes.ADVANCED_SEARCH_RESULT_DOCKET_UPDATE]: (state, { payload }) =>
    state.setIn(['data', 'results', payload.docket.id], payload.docket),

  [actionTypes.ADVANCED_SEARCH_ALERT.REQUEST]: (state, { data }) => {
    return state.mergeDeep(
      Immutable.fromJS({
        alert: {
          isLoading: true,
          error: null,
          data,
        },
      })
    );
  },

  [actionTypes.ADVANCED_SEARCH_ALERT.ERROR]: (state, { error }) => {
    return state.mergeDeep(
      Immutable.fromJS({
        alert: {
          isLoading: false,
          error,
        },
      })
    );
  },

  [actionTypes.ADVANCED_SEARCH_ALERT.SUCCESS]: (state, { data }) => {
    const m = state.mergeDeep(
      Immutable.fromJS({
        alert: {
          isLoading: false,
          data,
          error: null,
        },
      })
    );
    return m;
  },
});



// WEBPACK FOOTER //
// ./src/redux/reducers/advancedSearchReducer.js